import React, { useEffect, useState } from 'react';

const CSCarousel = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000); 

    return () => clearInterval(interval);
  }, [slides.length]);

  if (!slides || slides.length === 0) {
    return <div className="banner-container">No slides available</div>;
  }

  return (
    <div className="col-12 hidden banner-container border-bottom-3 border-primary-light lg:block ">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`slide ${index === currentSlide ? "active" : ""}`}
        >
          <img
            src={slide.image}
            alt={`Slide ${slide.id}`}
            className="banner-image "
            role="img"
            aria-label={`Slide ${index + 1} of ${slides.length}`}
          />
        </div>
      ))}
    </div>
  );
};

export default CSCarousel;
